import { Table, Button } from "antd";
import { useState } from "react";
import UserEditModal from "./UserEditModal";

export default function UserAdminIndex({ users, loading, onUpdateSuccess }) {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editingUser, setEditingUser] = useState(null);

  const showEditModal = (user) => {
    setEditingUser(user);
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setEditingUser(null);
  };

  const columns = [
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Nombre",
      dataIndex: "nombre",
      key: "nombre",
    },
    {
      title: "Apellido",
      dataIndex: "apellido",
      key: "apellido",
    },
    {
      title: "Rol",
      dataIndex: "rol",
      key: "rol",
    },
    {
      title: "Activo",
      dataIndex: "activo",
      key: "activo",
      render: (activo) => (activo ? "Sí" : "No"),
    },
    {
      title: "Acciones",
      key: "acciones",
      render: (_, record) => (
        <Button type="link" onClick={() => showEditModal(record)}>
          Editar
        </Button>
      ),
    },
  ];

  return (
    <>
      <Table dataSource={users} columns={columns} loading={loading} rowKey="email" />
      {editingUser && (
        <UserEditModal
          visible={isModalVisible}
          onCancel={handleCancel}
          user={editingUser}
          onUpdateSuccess={onUpdateSuccess}
        />
      )}
    </>
  );
}
